import { TransactionApiItem } from "services/api.services/UserTransaction/UserTransactionService";

export enum WalletActionTypes {
  FETCH_WALLET_REQUEST = "wallet/FETCH_WALLET_REQUEST",
  FETCH_WALLET_SUCCESS = "wallet/FETCH_WALLET_SUCCESS",
  FETCH_WALLET_FAILURE = "wallet/FETCH_WALLET_FAILURE",
  HYDRATE_FROM_LOGIN = "wallet/HYDRATE_FROM_LOGIN",
  CLEAR_WALLET = "wallet/CLEAR_WALLET",
}

export type WalletDirection = "CREDIT" | "DEBIT";

export interface WalletInfo {
  hasWallet: boolean;
  walletPublicKey: string | null;
  walletType: string | null;
  isKyc: boolean;
  isMinKyc: boolean;
  kycState: string | null;
  activeBalance: number;
  encWalletToken: string | null;
  encWalletTokenIV: string | null;
  expiryTime: number | null;
  userId: string; // login response se aayega
}

export interface WalletTransaction {
  id: string; // internal id
  userId: string;
  createdAt: string; // ISO string
  title: string; // e.g. "Paid for order at Anil Yadav"
  subtitle: string; // e.g. "17 JAN, 1:31 PM"
  source: string; // e.g. "FROM UPI" ya merchant name
  orderId?: string | null;
  transactionId?: string | null;
  bankTxnId?: string | null;

  direction: WalletDirection; // "CREDIT" | "DEBIT"
  amount: number;
  currency?: string; // default "₹"
  status: "SUCCESS" | "PENDING" | "FAILED" | string;

  iconUrl?: string | null;
}

export interface WalletState {
  info: WalletInfo | null;
  // transactions: WalletTransaction[];
  transactions: TransactionApiItem[];
  loading: boolean;
  error: string | null;
}
